import { render, staticRenderFns } from "./BgFormUpload.vue?vue&type=template&id=0b996d77"
import script from "./BgFormUpload.vue?vue&type=script&lang=js"
export * from "./BgFormUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports